import map from 'lodash/map';
import React from 'react';
import cx from 'classnames';
import s from './LinksList.module.scss';
import { ReactNode } from 'react';

export interface LinksListItem {
	name: string;
	selected?: boolean;
	itemKey?: string;
	itemClass?: string;
	onClick?: () => void;
	child?: ReactNode;
	linkClass?: boolean;
	linkClassDesktop?: boolean;
}

interface Props {
	items: LinksListItem[];
}
const LinksList = ({ items, linkClass = '', linkClassDesktop }: Props) => {
	return (
		<nav
			className={cx(s.list, s.hideScrollBar, {
				[s.linkClass]: linkClass,
				[s.linkClassDesktop]: linkClassDesktop,
			})}
		>
			<ul>
				{map(items, (item, index) => {
					const { name, selected, itemKey, itemClass = '', onClick = () => {}, child } = item;
					return (
						<li
							onClick={onClick}
							key={itemKey || index}
							className={cx({
								[s.active]: selected,
								[itemClass]: itemClass,
							})}
						>
							{child ? child : name}
							<div className={cx({ [s.line]: selected })} />
						</li>
					);
				})}
			</ul>
		</nav>
	);
};

export default LinksList;
